function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { values } from 'ramda';
import { ApiConstants, CoreLocaleKeys, i18n, InjectorHelper, ThunkHelper } from 'invision-core';
import { NOTIFICATION_TIME_LENGTH } from '../../customercare.constants';
export var ADD_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE = 'ADD_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE';
export var addImportBulkServiceAttributesJobPendingFile = function addImportBulkServiceAttributesJobPendingFile(pendingFile) {
  return {
    payload: pendingFile,
    type: ADD_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE
  };
};
export var CLEAR_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILES = 'CLEAR_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILES';
export var clearImportBulkServiceAttributesJobPendingFiles = function clearImportBulkServiceAttributesJobPendingFiles() {
  return {
    type: CLEAR_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILES
  };
};
export var CLEAR_IMPORT_BULK_SERVICE_ATTRIBUTES_JOBS_PENDING_UPDATED_STATUS = 'CLEAR_IMPORT_BULK_SERVICE_ATTRIBUTES_JOBS_PENDING_UPDATED_STATUS';
export var clearImportBulkServiceAttributesJobsPendingUpdatedStatus = function clearImportBulkServiceAttributesJobsPendingUpdatedStatus() {
  return {
    type: CLEAR_IMPORT_BULK_SERVICE_ATTRIBUTES_JOBS_PENDING_UPDATED_STATUS
  };
};
export var REMOVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE = 'REMOVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE';
export var removeImportBulkServiceAttributesJobPendingFile = function removeImportBulkServiceAttributesJobPendingFile(pendingFileName) {
  return {
    payload: pendingFileName,
    type: REMOVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE
  };
};
export var RETRIEVE_AWS_S3_UPLOAD_CONFIGURATION = {
  BEGIN: 'RETRIEVE_AWS_S3_UPLOAD_CONFIGURATION_BEGIN',
  SUCCESS: 'RETRIEVE_AWS_S3_UPLOAD_CONFIGURATION_SUCCESS',
  FAILURE: 'RETRIEVE_AWS_S3_UPLOAD_CONFIGURATION_FAILURE'
};
export var retrieveAwsS3UploadConfigurationPromise = function retrieveAwsS3UploadConfigurationPromise(dispatch, fileName, uploadFileType, orderId, pricingPlanId, customerId) {
  var payload = {
    FileName: fileName,
    FileType: uploadFileType,
    OrderId: orderId,
    PricingPlanId: pricingPlanId
  };
  return ThunkHelper(dispatch, values(RETRIEVE_AWS_S3_UPLOAD_CONFIGURATION), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveBulkOrderUploadUrl',
    data: payload,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, payload);
};
export var retrieveAwsS3UploadConfiguration = function retrieveAwsS3UploadConfiguration(fileName, uploadFileType, orderId, pricingPlanId, customerId) {
  return function (dispatch) {
    return retrieveAwsS3UploadConfigurationPromise(dispatch, fileName, uploadFileType, orderId, pricingPlanId, customerId).catch(function () {
      InjectorHelper.getUiNotificationService().error(i18n.translate(CoreLocaleKeys.UPLOAD.UNABLE_TO_LOAD_CONFIG_ERROR.MESSAGE), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};
export var RETRIEVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_DETAILS = {
  BEGIN: 'RETRIEVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_DETAILS_FAILURE'
};
export var retrieveImportBulkServiceAttributesJobDetailsPromise = function retrieveImportBulkServiceAttributesJobDetailsPromise(dispatch, orderDetails, fileDetails) {
  var payload = {
    BulkExtractJobId: orderDetails.jobId,
    FileLocation: fileDetails.path || null,
    OrderId: orderDetails.orderId,
    PricingPlanId: orderDetails.pricingPlanId
  };
  return ThunkHelper(dispatch, values(RETRIEVE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_DETAILS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveBulkFileExtractDetail',
    data: payload,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, orderDetails.customerId)
  }, payload);
};
export var retrieveImportBulkServiceAttributesJobDetails = function retrieveImportBulkServiceAttributesJobDetails(orderDetails) {
  var fileDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch) {
    return retrieveImportBulkServiceAttributesJobDetailsPromise(dispatch, orderDetails, fileDetails).catch(function (error) {
      InjectorHelper.getUiNotificationService().error(error.translatedMessage, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};
export var SEND_BULK_SERVICE_ATTRIBUTES_UPLOAD_NOTIFICATION = {
  BEGIN: 'SEND_BULK_SERVICE_ATTRIBUTES_UPLOAD_NOTIFICATION_BEGIN',
  SUCCESS: 'SEND_BULK_SERVICE_ATTRIBUTES_UPLOAD_NOTIFICATION_SUCCESS',
  FAILURE: 'SEND_BULK_SERVICE_ATTRIBUTES_UPLOAD_NOTIFICATION_FAILURE'
};
export var sendBulkServiceAttributesUploadNotificationPromise = function sendBulkServiceAttributesUploadNotificationPromise(dispatch, orderDetails, fileDetails) {
  var payload = {
    BulkExtractJobId: orderDetails.jobId,
    FileLocations: [fileDetails.path],
    OfferingId: orderDetails.offeringId,
    OrderId: orderDetails.orderId,
    PricingPlanId: orderDetails.pricingPlanId
  };
  return ThunkHelper(dispatch, values(SEND_BULK_SERVICE_ATTRIBUTES_UPLOAD_NOTIFICATION), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveBulkServicesFileUploadConfirmation',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, orderDetails.subscriberId),
    data: payload
  }, payload);
};
export var sendBulkServiceAttributesUploadNotification = function sendBulkServiceAttributesUploadNotification(orderDetails, fileDetails) {
  return function (dispatch) {
    return sendBulkServiceAttributesUploadNotificationPromise(dispatch, orderDetails, fileDetails).catch(function (error) {
      InjectorHelper.getUiNotificationService().error(error.translatedMessage, null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });

      // NOTE: Pass-through error so it can also be displayed in-line with the corresponding file
      return Promise.reject(error);
    });
  };
};
export var SET_CURRENT_TAB = 'SET_ORDER_DETAILS_CURRENT_TAB';
export var setCurrentTab = function setCurrentTab(tab) {
  return {
    type: SET_CURRENT_TAB,
    payload: tab
  };
};
export var SET_IS_IMPORTING_BULK_SERVICE_ATTRIBUTES = 'SET_IS_IMPORTING_BULK_SERVICE_ATTRIBUTES';
export var setIsImportingBulkServiceAttributes = function setIsImportingBulkServiceAttributes() {
  var isImporting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    payload: isImporting,
    type: SET_IS_IMPORTING_BULK_SERVICE_ATTRIBUTES
  };
};
export var UPDATE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE_STATUS = 'UPDATE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE_STATUS';
export var updateImportBulkServiceAttributesJobPendingFileStatus = function updateImportBulkServiceAttributesJobPendingFileStatus(pendingFileName, status) {
  return {
    payload: {
      name: pendingFileName,
      status: status
    },
    type: UPDATE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_FILE_STATUS
  };
};
export var UPDATE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOBS_PENDING_UPDATED_STATUS = 'UPDATE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOBS_PENDING_UPDATED_STATUS';
export var updateImportBulkServiceAttributesJobsPendingUpdatedStatus = function updateImportBulkServiceAttributesJobsPendingUpdatedStatus(pricingPlanIds) {
  return {
    payload: pricingPlanIds,
    type: UPDATE_IMPORT_BULK_SERVICE_ATTRIBUTES_JOBS_PENDING_UPDATED_STATUS
  };
};
export var RETRIEVE_BULK_SERVICES_TEMPLATE_CONSTANTS = {
  BEGIN: 'RETRIEVE_BULK_SERVICES_TEMPLATE_BEGIN',
  SUCCESS: 'RETRIEVE_BULK_SERVICES_TEMPLATE_SUCCESS',
  FAILURE: 'RETRIEVE_BULK_SERVICES_TEMPLATE_FAILURE'
};
export var RETRIEVE_BULK_SERVICES_TEMPLATE_EVENTS = [RETRIEVE_BULK_SERVICES_TEMPLATE_CONSTANTS.BEGIN, RETRIEVE_BULK_SERVICES_TEMPLATE_CONSTANTS.SUCCESS, RETRIEVE_BULK_SERVICES_TEMPLATE_CONSTANTS.FAILURE];
export var retrieveBulkServicesTemplatePromise = function retrieveBulkServicesTemplatePromise(dispatch, orderDetails) {
  return ThunkHelper(dispatch, RETRIEVE_BULK_SERVICES_TEMPLATE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveBulkServicesTemplate',
    data: {
      OrderId: orderDetails.orderId,
      PricingPlanId: orderDetails.pricingPlanId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, orderDetails.customerId)
  }, {
    OrderId: orderDetails.orderId,
    PricingPlanId: orderDetails.pricingPlanId
  });
};
export var retrieveBulkServicesTemplate = function retrieveBulkServicesTemplate(orderDetails) {
  return function (dispatch) {
    return retrieveBulkServicesTemplatePromise(dispatch, orderDetails);
  };
};
export var SET_CHANGE_FDO_EXECUTION_OPTIONS = 'SET_CHANGE_FDO_EXECUTION_OPTIONS';
export var setExecutionOptions = function setExecutionOptions(executionOptions) {
  return {
    type: SET_CHANGE_FDO_EXECUTION_OPTIONS,
    payload: executionOptions
  };
};
export var UPDATE_FDO_EXECUTION_DATE_CONSTANTS = {
  BEGIN: 'UPDATE_FDO_EXECUTION_DATE_BEGIN',
  SUCCESS: 'UPDATE_FDO_EXECUTION_DATE_SUCCESS',
  FAILURE: 'UPDATE_FDO_EXECUTION_DATE_FAILURE'
};
export var UPDATE_FDO_EXECUTION_DATE_EVENTS = [UPDATE_FDO_EXECUTION_DATE_CONSTANTS.BEGIN, UPDATE_FDO_EXECUTION_DATE_CONSTANTS.SUCCESS, UPDATE_FDO_EXECUTION_DATE_CONSTANTS.FAILURE];
export var updateFdoExecutionDatePromise = function updateFdoExecutionDatePromise(dispatch) {
  var executionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var orderId = arguments.length > 2 ? arguments[2] : undefined;
  return ThunkHelper(dispatch, UPDATE_FDO_EXECUTION_DATE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateFutureDatedOrderExecutionDate',
    data: {
      BillingEffectiveDate: executionOptions.billingEffectiveDate || undefined,
      BillingEffectiveDateIntention: executionOptions.billingEffectiveIntention || undefined,
      ExecutionDate: executionOptions.specifiedDate || undefined,
      ExecutionDateIntention: executionOptions.effective || undefined,
      OrderId: orderId
    }
  });
};
export var updateFdoExecutionDate = function updateFdoExecutionDate(executionDate, orderId) {
  return function (dispatch) {
    return updateFdoExecutionDatePromise(dispatch, executionDate, orderId);
  };
};
export var ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT = {
  BEGIN: 'ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT_BEGIN',
  SUCCESS: 'ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT_SUCCESS',
  FAILURE: 'ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT_FAILURE'
};
var ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT_TYPES = [ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT.BEGIN, ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT.SUCCESS, ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT.FAILURE];
export var retrieveOrderContext = function retrieveOrderContext(orderDetails) {
  return function (dispatch) {
    return retrieveOrderContextPromise(dispatch, orderDetails);
  };
};
export var retrieveOrderContextPromise = function retrieveOrderContextPromise(dispatch) {
  var orderDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var params = {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderContext',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, orderDetails.SubscriberId),
    data: {
      OrderId: orderDetails.Id || undefined
    }
  };
  return ThunkHelper(dispatch, ORDER_DETAILS_RETRIEVE_ORDER_CONTEXT_TYPES, params);
};